var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileNavContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.632,
    height: 13.632,
    viewBox: "0 0 13.632 13.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_nav_contact_icon",
    transform: "translate(-33.842 -764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_16dbb592bea1e5502e63762404d50631",
    "data-name": "16dbb592bea1e5502e63762404d50631",
    d: "M8.9,1a6.2,6.2,0,1,0,1.984,12.068l2.706,1.492L13.356,11.5A6.2,6.2,0,0,0,8.9,1Zm1.908,3.047.656-.681-.669-.645-.664.69a2.6,2.6,0,0,0-1.385-.4A2.4,2.4,0,0,0,6.266,5.338a2.254,2.254,0,0,0,.92,1.807A1.308,1.308,0,0,0,6.391,8.3a.919.919,0,0,0,.372.771,1.4,1.4,0,0,0,.714.232,7.432,7.432,0,0,0,1.2-.048h0l.331-.029a3.273,3.273,0,0,1,1.257.062.5.5,0,0,1,.255.179.727.727,0,0,1,.1.423.947.947,0,0,1-.321.777,1.686,1.686,0,0,1-.92.332,4.057,4.057,0,0,1-2.393-.551l-.5.781a4.979,4.979,0,0,0,2.993.7A2.6,2.6,0,0,0,10.9,11.38a1.872,1.872,0,0,0,.65-1.487,1.64,1.64,0,0,0-.264-.95,1.421,1.421,0,0,0-.7-.524A4.089,4.089,0,0,0,8.933,8.3c-.143.011-.279.024-.408.035h0a6.042,6.042,0,0,1-.968.042c-.532-.045.056-.428.286-.511a4.365,4.365,0,0,1,.823-.189h0l.123-.02a2.4,2.4,0,0,0,2.435-2.323A2.2,2.2,0,0,0,10.807,4.047Zm-2.063-.1A1.478,1.478,0,0,0,7.2,5.338,1.478,1.478,0,0,0,8.744,6.732a1.478,1.478,0,0,0,1.549-1.394A1.478,1.478,0,0,0,8.744,3.943Zm-3.563,10A3.753,3.753,0,0,0,6.207,13.8,7.138,7.138,0,0,1,1.9,8.53a3.655,3.655,0,0,0,.61,4.285l-.14,1.817,1.624-.887A3.748,3.748,0,0,0,5.181,13.939Z",
    transform: "translate(32.379 763)",
    fill: "#7c4dff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139028",
    "data-name": "\\uD328\\uC2A4 139028",
    d: "M5.117,0A5.117,5.117,0,1,1,0,5.117,5.117,5.117,0,0,1,5.117,0Z",
    transform: "translate(35.935 765.248)",
    fill: "#7c4dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139022",
    "data-name": "\\uD328\\uC2A4 139022",
    d: "M6.84,9.245h7.873a.55.55,0,0,0,.59-.5.55.55,0,0,0-.59-.5H6.84a.55.55,0,0,0-.59.5A.55.55,0,0,0,6.84,9.245ZM8.612,11.4a.55.55,0,0,1,.59-.5h5.511a.5.5,0,1,1,0,.995H9.2A.55.55,0,0,1,8.612,11.4Z",
    transform: "translate(30.274 760.291)",
    fill: "#f1f9ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNavContactIcon);
export default __webpack_public_path__ + "static/media/mobile_nav_contact_icon.37f71275168a7c3db00aa9159f8bef8f.svg";
export { ForwardRef as ReactComponent };